import { connect } from 'react-redux'
import List from '../../Main/Profile/_List'
import { selectMedal } from '../../../actions'

const mapStateToProps = state => ({
  list_name: 'Nuevas Medallas',
  empty_message: '¡Esta misión no dió medallas!',
  items: state.missions.answerMission.progress.earned_for_winning.new_medals.map(x =>
    ({ ...x, text: x.description }),
  ),
})

const mapDispatchToProps = dispatch => ({
  toggleDialog: (id, toggleOpen) => {
    dispatch(selectMedal({ id }))
    toggleOpen()
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/NewMedals/index.jsx